import { Wishlist } from '@ynap/api-utils';
import { FETCH_NAVIGATION_PREFIX, views, MODAL_CLOSED, MODAL_RESET_ERROR } from '../constants';
import { apiAuthenticatedRequest, noUberTokenError } from '../utils/apiCall';
import { getCommerceConfig, getHeadConfig } from '../selectors/getConfig';
import { getMessages, getUserState, getWishlistState, getPdpUrlTemplate } from '../selectors';
import { productSelectors } from '@ynap/product-state';
import { authActions } from '@ynap/auth-state';
const { getProductLinkByPartNumber } = productSelectors;

function requestWishlists(requestParameters) {
    const {
        dispatch,
        options,
        user,
        messages,
        uniqueID,
        view,
        locale,
        redirectToLoginParams,
        langId,
        baseUrl,
        brandId,
        country,
        clientId,
        uberToken,
        isActionDelayed = false,
    } = requestParameters;

    options.user = user;
    options.messages = messages;
    options.selectedId = uniqueID;
    options.view = view;
    options.locale = locale;
    options.errorTags = ['fetchWishlistsError', 'wishlistError'];
    options.bypassCreateGuestUbertoken = true;
    options.redirectToLoginParams = redirectToLoginParams;

    const getAllWishlistsOptions = {
        ...(langId && { langId }),
    };

    // We've added this setTimeout in order to avoid race condition between 2 requests (/cart/@self and /@self/wishlist).
    // Since they both trigger at the same time this would result on a 503 HTTP Error.
    // This is a use case for the head Blue Lobster
    return new Promise((resolve) => {
        setTimeout(
            () => {
                return resolve(
                    dispatch(
                        apiAuthenticatedRequest(
                            Wishlist.getAllWishlists({ baseUrl, brandId, country, getAllWishlistsOptions, clientId, uberToken }),
                            FETCH_NAVIGATION_PREFIX,
                            locale,
                            options,
                        ),
                    ),
                );
            },
            !isActionDelayed ? 0 : 4000,
        );
    });
}

export function fetchNavigation(options = {}, skuPartNumber) {
    return (dispatch, getState) => {
        const state = getState();
        const { baseUrl, brandId, clientId, country, locale, uberToken, langId } = getCommerceConfig(state);
        const { user } = getUserState(state);
        const { wishlist } = getWishlistState(state);
        const {
            pdp: { enableSignInModal = false },
        } = getHeadConfig(state);

        const { uniqueID, view = views.BASE } = wishlist || {};
        const messages = getMessages(state);
        const productUrl = skuPartNumber && getProductLinkByPartNumber(getPdpUrlTemplate(state), locale, undefined, skuPartNumber);
        const redirectToLoginParams = productUrl ? { redirect: `${productUrl}?mode=addToWishlist` } : {};
        const { setUberToken } = authActions;
        const isGuestUser = uberToken && !user;
        const isUserRemembered = uberToken && user?.userAuthenticationStatus?.toLowerCase() !== 'full';

        // Enables the Sign in modal (if the flag is enabled) to Not Logged Users, Guest Users, Remembered Users
        if ((!uberToken && !options.guestAccessKey) || (isGuestUser && enableSignInModal) || (isUserRemembered && enableSignInModal)) {
            if (window?.SF?.openSignInDialog && enableSignInModal) {
                window.SF.openSignInDialog('product details page')
                    .then((uberToken) => {
                        dispatch(setUberToken(uberToken));
                        return requestWishlists({
                            dispatch,
                            options,
                            user,
                            messages,
                            uniqueID,
                            view,
                            locale,
                            redirectToLoginParams,
                            langId,
                            baseUrl,
                            brandId,
                            country,
                            clientId,
                            uberToken,
                            isActionDelayed: true,
                        });
                    })
                    .catch(() => {
                        // This dispatch action exists so that we can open and close the modal and report always an error
                        dispatch({ type: MODAL_RESET_ERROR });
                        dispatch({ type: MODAL_CLOSED });
                    });
            } else {
                // This condition remains the same since TON does not have the SignIn Dialog yet
                return dispatch(noUberTokenError(uberToken, FETCH_NAVIGATION_PREFIX, locale, redirectToLoginParams));
            }
        } else {
            return requestWishlists({
                dispatch,
                options,
                user,
                messages,
                uniqueID,
                view,
                locale,
                redirectToLoginParams,
                langId,
                baseUrl,
                brandId,
                country,
                clientId,
                uberToken,
            });
        }
    };
}
